import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="none"
    {...props}
  >
    <path
      stroke="#111"
      strokeWidth={2}
      d="M11.001 2.836A8.167 8.167 0 1 1 11 19.169 8.167 8.167 0 0 1 11 2.836Z"
    />
    <path
      stroke="#111"
      strokeLinecap="round"
      strokeWidth={2}
      d="M11 10.086v4.583"
    />
    <path
      fill="#111"
      fillRule="evenodd"
      d="M11 8.255a.917.917 0 1 0 0-1.833.917.917 0 0 0 0 1.833Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgComponent
